import { render, staticRenderFns } from "./PanelEvaluaciones.vue?vue&type=template&id=04c8dfee"
import script from "./PanelEvaluaciones.vue?vue&type=script&lang=js"
export * from "./PanelEvaluaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports